// extracted by mini-css-extract-plugin
module.exports = {"container":"LottiePlayer_container__uW6hm"};